goog.provide('el8.appchart.mainFeeds.menu');
goog.provide('el8.appchart.mainFeeds.twoColumnMenu');

goog.require('el8.uiwidget.NewActionsMenu');

el8.appchart.mainFeeds.menu = new el8.uiwidget.NewActionsMenu({
    container: $('#main-feed-container'),
    anchorTop: $('#chart-feed-contents'),
    menuId: 'main-feed-actions-menu',
    width: 270,
    highlightClass: 'el8FeedItemNewSelected'
});

el8.appchart.mainFeeds.twoColumnMenu = new el8.uiwidget.NewActionsMenu({
    container: $('#main-feed-container'),
    anchorTop: $('#chart-feed-contents'),
    menuId: 'main-feed-actions-two-column-menu',
    highlightClass: 'el8FeedItemNewSelected',
    width: 400,
    twoColumn: true
});
